/**
===================================================
Module: frontend.src.stores.sessionCreationStore.ts
Description: Zustand store for session creation state management
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/

import { create } from "zustand";
import { CreateSessionRequest } from "../types";

interface SessionCreationState {
  // Session data
  sessionData: CreateSessionRequest | null;
  videoFile: File | null;
  thumbnailBlob: Blob | null;
  isGeneratingThumbnail: boolean;

  // Actions
  setSessionData: (data: CreateSessionRequest | null) => void;
  setVideoFile: (file: File | null) => void;
  setThumbnailBlob: (blob: Blob | null) => void;
  setIsGeneratingThumbnail: (isGenerating: boolean) => void;
  resetState: () => void;
  clearState: () => void;
}

export const useSessionCreationStore = create<SessionCreationState>(
  (set, get) => ({
    // Initial state
    sessionData: null,
    videoFile: null,
    thumbnailBlob: null,
    isGeneratingThumbnail: false,

    // Actions
    setSessionData: (data) => {
      set({ sessionData: data });
    },
    setVideoFile: (file) => {
      set({ videoFile: file });
    },
    setThumbnailBlob: (blob) => {
      set({ thumbnailBlob: blob });
    },
    setIsGeneratingThumbnail: (isGenerating) =>
      set({ isGeneratingThumbnail: isGenerating }),

    resetState: () => {
      set({
        sessionData: null,
        videoFile: null,
        thumbnailBlob: null,
        isGeneratingThumbnail: false,
      });
    },

    clearState: () => {
      set({
        sessionData: null,
        videoFile: null,
        thumbnailBlob: null,
        isGeneratingThumbnail: false,
      });
    },
  }),
);
